import React from 'react';
import { FuelGridContainer, FuelGridItem } from '@frete.com/fuel-react';
import { FuelOriginAndDestination } from '@frete.com/fuel-station-react';
import TruckerInfo from '@components/ui/Trucker/TruckerInfo';
import Actions from './Actions';
import { JourneysItemPropsInterface } from './JourneysItemTypes';

function JourneysItem({ id, trucker, waypoints }: JourneysItemPropsInterface) {
  return (
    <FuelGridContainer gapRow={0}>
      <FuelGridItem lg={4} xlg={4}>
        <TruckerInfo
          avatar={trucker.avatar}
          name={trucker.name}
          plate={trucker.vehicle.plates[0]}
          depositFee={trucker.depositFee}
          showIn="journey"
          journeyId={id}
        />
      </FuelGridItem>
      <FuelGridItem lg={5} xlg={5}>
        <FuelOriginAndDestination
          origin={waypoints.pickup}
          destination={waypoints.delivery}
          isLarge={false}
        />
      </FuelGridItem>
      <FuelGridItem lg={3} xlg={3}>
        <Actions id={id} />
      </FuelGridItem>
    </FuelGridContainer>
  );
}

export default JourneysItem;
